import axios from "axios";
import router from "@/router";
import store from "@/store";
import { delLocalStorage, getLocalStorage } from "@/tools/localStorage";

let baseURL = process.env.VUE_APP_BASE_API;
// 建立axios例項
const service = axios.create({
  baseURL: baseURL,
  timeout: 30000, // 請求超時時間
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});
const err = (error) => {
  if (error.response) {
    let data = error.response.data;
    console.log(`message: ${data.msg}`);
    // 若發生權限錯誤則要求重新登入
    // 可能是沒有登入或是token過期
    if (error.response.data.code == 401) {
      router.push("/account/login");
      delLocalStorage("account_token");
      store.commit("setDialog", "會員憑證過期，請重新登入");
    }
    if (error.response.data.code == 302) {
      delLocalStorage("account_token");
      store.commit("setDialog", "會員憑證過期，請重新登入");
    }
  }
  return Promise.reject(error);
};
// request攔截器
service.interceptors.request.use((config) => {
  // 若有登入會員，則帶入token
  const token = getLocalStorage("account_token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
}, err);
// respone攔截器
service.interceptors.response.use((response) => {
  if (response.data.code == 401) {
    router.push("/account/login");
    delLocalStorage("account_token");
    store.commit("setDialog", "會員憑證過期，請重新登入");
  }
  if (response.data.code == 302) {
    delLocalStorage("account_token");
    store.commit("setDialog", "會員憑證過期，請重新登入");
  }
  return response.data;
}, err);
/*
 *  get請求
 *  url:請求地址
 *  params:引數
 * */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "get",
      params: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*
 *  put請求
 *  url:請求地址
 *  params:引數
 * */
export function put(url, params = {}) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "put",
      data: params,
    })
      .then((response) => {
        resolve(response);
        response.code != 200 ? console.log(response) : "";
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*
 *  patch請求
 *  url:請求地址
 *  params:引數
 * */
export function patch(url, params = {}) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "patch",
      data: params,
    })
      .then((response) => {
        resolve(response);
        response.code != 200 ? console.log(response) : "";
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*
 *  delete請求
 *  url:請求地址
 *  params:引數
 * */
export function del(url) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "delete",
    })
      .then((response) => {
        response.code != 200 ? console.log(response) : "";
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*
 *  post請求
 *  url:請求地址
 *  params:引數
 * */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "post",
      data: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  get,
  put,
  del,
  patch,
};
